import { truncateNumber } from "../../../../helpers/operationMath"

const getListBar = (listArea = [], { folderName, sectionInstalledCapacity }) => {
    const barBreakdown = {}
    const keysBarBreakdown = []
    const listContainerBarBreakdown = []


    listArea.forEach((item) => {
        keysBarBreakdown.push(item.listName)
        barBreakdown.section = folderName
        barBreakdown[item.listName] = truncateNumber(item.totalTimeSpent)
        barBreakdown[`${item.listName}Colors`] = item.color
        listContainerBarBreakdown.push({
            label: item.listName,
            value: truncateNumber(item.totalTimeSpent),
            color: item.color,
            extra: {
                percentage: truncateNumber(item.totalTimeSpent / sectionInstalledCapacity * 100),
            }
        })
    })

    return {
        folderName,
        barBreakdown,
        keysBarBreakdown,
        listContainerBarBreakdown
    }

}


export const getSelectArea = (areaSelect) => {
    const folderBreakdown = []
    const listByFolder = []
    const bar = {
        barBreakdown: [],
        keysBarBreakdown: [],
    }

    areaSelect.folders.forEach((item) => {
        const listData = getListBar(item.lists, { folderName: item.folderName, sectionInstalledCapacity: areaSelect.sectionInstalledCapacity })
        listByFolder.push(listData)
        folderBreakdown.push({
            label: item.folderName,
            value: truncateNumber(item.folderTotalTimeSpent),
            color: item.color,
            extra: {
                percentage: truncateNumber(item.folderTotalTimeSpent / areaSelect.sectionInstalledCapacity * 100),
            }
        })
    })

    listByFolder.forEach((item) => {
        const { barBreakdown, keysBarBreakdown } = item
        bar.keysBarBreakdown.push(...keysBarBreakdown)
        bar.barBreakdown.push(barBreakdown)
    })

    return {
        folderBreakdown,
        listBarContainer: listByFolder,
        ...bar
    }
}